import { Input, Modal, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { IShoppingCart } from "../../models/IShoppingCartModel";
import { applyVoucherCode } from "../../redux/reducers/slice/cart";
import { checkVoucherCode } from "../../services/shoppingCart";
import { getVoucherInfo } from "../../utils/helpers";

interface IInputVoucherCodeProps {
  t: any;
  carts: IShoppingCart;
  isExpiredVoucherCode: boolean;
  handleChangeVoucherCode: Function;
}

const InputVoucherCode = ({
  t,
  carts,
  isExpiredVoucherCode,
}: IInputVoucherCodeProps) => {
  const [open, setOpen] = useState<boolean>();
  const [code, setCode] = useState<string>();
  const [voucherName, setVoucherName] = useState<string>();
  const [voucherCode, setVoucherCode] = useState<string>();
  const [error, setError] = useState<string>();
  const dispatch = useDispatch();
  const [hasDiscount, setHasDiscount] = useState<boolean>(false);

  useEffect(() => {
    if (carts.total_amount_discount) {
      setHasDiscount(true);
    } else {
      setHasDiscount(false);
    }
  }, [carts]);

  useEffect(() => {
    getCode();
  }, [carts?.order_voucher]);

  const getCode = () => {
    if (carts?.order_voucher?.code) {
      setCode(carts?.order_voucher?.code);
    } else {
      setCode(voucherCode || "");
    }

    const voucherInfo = getVoucherInfo();

    if (carts?.order_voucher?.name) {
      setVoucherName(carts?.order_voucher?.name);
      setVoucherCode(carts?.order_voucher?.code);
    } else if (voucherInfo && voucherInfo.code) {
      setVoucherName(voucherInfo.name);
      setVoucherCode(voucherInfo.code);
    } else {
      setVoucherName("");
      setVoucherCode("");
    }
  };

  const handleChangeVoucherCode = () => {
    if (!code || !code.trim()) {
      dispatch(applyVoucherCode(undefined));
      setOpen(false);
      return;
    }
    setVoucherName("");
    setVoucherCode("");
    setError("");
    checkVoucherCode(code.trim())
      .then((rs) => {
        if (rs.data) {
          dispatch(applyVoucherCode(rs.data));
          setVoucherName(rs.data.name);
          setVoucherCode(rs.data.code);
          setOpen(false);
        } else {
          setError(rs.statusText);
        }
      })
      .catch((err) => {
        if (err) {
          setError(err.message);
        }
      });
  };

  const handelClickOpenModel = () => {
    getCode();
    setError("");
    setOpen(true);
  };

  const handelClose = () => {
    setOpen(false);
  };

  const handleOk = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
    e.preventDefault();
    handleChangeVoucherCode();
  };

  return (
    <>
      <div className="sc-voucher-code-wrap">
        <span
          className="shopping-cart-summary-item-label voucher-code-label sub-content"
          onClick={handelClickOpenModel}
          title={""}>
          {!voucherCode
            ? t("shopping_cart_input_voucher_code_title")
            : voucherCode}
        </span>
        {voucherName ? (
          <span className="shopping-cart-voucher-name main-content">
            {!isExpiredVoucherCode
              ? voucherName
              : t("shopping_cart_expired_voucher_code")}
          </span>
        ) : null}
      </div>
      <div className="shopping-cart-summary-item-value shopping-cart-discount-vat">
        <span className="sub-title">
          {hasDiscount ? carts.total_amount : null}
        </span>
        <span className="shopping-cart-vat main-content">
          (Giá đã bao gồm VAT)
        </span>
      </div>
      <Modal
        title={t("shopping_cart_input_voucher_code_title")}
        visible={open}
        cancelText={t("cancel")}
        okText={t("shopping_cart_apply_button")}
        onOk={handleOk}
        onCancel={handelClose}>
        <div>
          <Input
            placeholder={t("shopping_cart_voucher_code_placeholder")}
            allowClear
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            className="input-uppercase"
          />
          {voucherName && (
            <Typography.Text className="voucher-code-name" type="success">
              {voucherName}
            </Typography.Text>
          )}
          {error && (
            <Typography.Text className="voucher-code-name" type="danger">
              {error}
            </Typography.Text>
          )}
        </div>
      </Modal>
    </>
  );
};

export default InputVoucherCode;
